module.exports = __webpack_public_path__ + "static/media/record_gif.7758c8c1.gif";